import { Injectable } from '@angular/core';
import { SortDirection, SortType } from '../constants-types/Enums';
import {
    FilterInfo,
    FilterIndexContext
} from '../core-data-model/FilterInfo.model';
import { SortInfo } from '../core-data-model/SortInfo.model';
import {
    ODataQueryGeneratorService,
    KeyValue,
    UnknownFilterTypeError
} from '../core-services/ODataQueryGenerator.service';

@Injectable({ providedIn: 'root' })
export class UserQueryGeneratorService extends ODataQueryGeneratorService {
    getSearchParameters(_filterState: FilterInfo[]): KeyValue[] {
        return [];
    }

    getOrderbyParameter(sortingState: SortInfo[]): KeyValue[] {
        let oDataSort;
        const sortList = sortingState.map((sortInfo: SortInfo) => {
            const oDataDirection =
                sortInfo.direction === SortDirection.Ascending ? 'asc' : 'desc';
            switch (sortInfo.sortType) {
                case SortType.Name:
                    return `${`lastName`} ${oDataDirection}, ${`firstName`} ${oDataDirection}`;
                case SortType.Email:
                    oDataSort = 'email';
                    break;
                case SortType.Role:
                    oDataSort = 'userRoleName';
                    break;
                case SortType.Access:
                    oDataSort = 'isEnabled';
                    break;
                default:
                    throw new UnknownFilterTypeError();
            }
            return `${oDataSort} ${oDataDirection}`;
        });
        if (sortList.length > 0) {
            return [
                {
                    key: '$orderby',
                    value: sortList.join(',')
                }
            ];
        }
        return [];
    }

    protected filterFilterList(filters: FilterInfo[]): FilterInfo[] {
        return filters;
    }

    protected makeFilterContext() {
        return {
            indexContext: FilterIndexContext.Users,
            showCognitive: this.userProfile.showCognitive,
            userGuid: this.initData.user.userGuid
        };
    }
}
